
export const getPins = (props, component) => {
  const { orders, locationShop, driversRealTime } = props;
  const { lat, lng } = locationShop;
  component.setState({ orders, drivers: driversRealTime });
  if (lng !== 'undefined' && lat !== 'undefined' && lat && lng) {
    component.setState({ center: locationShop });
  }
};
